import Page from './page';
import ProductData from '../model/product-data';
import FacetFilters from '../components/product/facet-filters';
import MatchingTires from '../components/product/matching-tires';

const PRODUCT_CLASSIFICATIONS_ENDPOINT = '/product/classifications';

const selectors = {
  bomClassifications: '.js-bomClassifications',
};

export default class ProductListPage extends Page {

  private readonly tireFacetFilters: FacetFilters;

  constructor(protected body: JQuery) {
    super();
    this.tireFacetFilters = new FacetFilters(body.find('.js-facetForm'));
    this.fetchBomClassifications();
    MatchingTires.initAll();
  }

  private fetchBomClassifications(): void {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    document.querySelectorAll<HTMLDivElement>(selectors.bomClassifications).forEach(async (element) => {
      const { code } = element.dataset;
      if (!code) return;
      const response = await fetch(`${PRODUCT_CLASSIFICATIONS_ENDPOINT}/${code}`);
      const productData = await response.json() as ProductData;

      const { isTire, isWheel } = productData;

      if (!isTire && !isWheel) {
        return;
      }
      // eslint-disable-next-line no-param-reassign
      element.outerHTML = this.getClassificationTemplate(productData);
    });
  }

  private getClassificationTemplate(productData: ProductData): string {
    let result = '';

    if (productData.tireRollingResistance && productData.tireWetBrakePerformance && (productData.tireNoiseClass || productData.tireNoise)) {
      result += `
      <div class="tire-icon__icon-label-row">
        <div class="tire-icon__icon-label-wrapper">
          <img 
            class="icon tire-icon__icon" 
            src="/_ui/responsive/common/images/icons/rolling-resistance.png" 
            alt="Rolling resistance" 
            title="Rolling resistance">
          <span class="tire-icon__icon-label">${productData.tireRollingResistance}</span>
        </div>
        <div class="tire-icon__icon-label-wrapper">
          <img 
            class="icon tire-icon__icon" 
            src="/_ui/responsive/common/images/icons/wet-brake-performance.png" 
            alt="Wet brake property" 
            title="Wet brake property">
          <span class="tire-icon__icon-label">${productData.tireWetBrakePerformance}</span>
        </div>
        <div class="tire-icon__icon-label-wrapper">
          <img class="icon tire-icon__icon" src="/_ui/responsive/common/images/icons/noise-level.png" alt="Outside noise" title="Outside noise">
          <span class="tire-icon__icon-label">${
  productData.tireNoiseClass ?? ''}${productData.tireNoiseClass && productData.tireNoise ? '/' : ''}${productData.tireNoise ?? ''
}</span>
        </div>
      </div>`;
    }

    if (productData.tireDimensions) {
      result += `<p class="product-bom-item__dimensions">${productData.tireDimensions}</p>`;
    }
    return result;
  }

}
